import { useLocalSearchParams } from 'expo-router';
import EventDetailEvents from '@/screens/EventDetailEvents';

export default function PrivateTabsOrganizationScheduleScheduleBEventIdIndexRoute() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  return <EventDetailEvents basePath="/organization" eventId={eventId} />;
}
